<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/calendar-icon-org.svg" alt=""></div>
            <div><h4 class="text-semibold">Reprogramar campaña</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <p class="mt-3">Ajusta la fecha de inicio de la campaña según la nueva planificación.</p>

            <div class="d-grid prospect-form mt-3">
                <div>
                    <label class="login-label" for="nueva_fecha"><p class="color-org d-inline">*</p> Fecha:</label>
                    <input class="crm-input" type="date" name="nueva_fecha" id="nueva_fecha" [(ngModel)]="newDate" /> 
                </div>
                <div>
                    <label class="login-label" for="nueva_fecha"><p class="color-org d-inline">*</p> Hora:</label>
                    <input class="crm-input" type="time" name="nueva_fecha" id="nueva_fecha" [(ngModel)]="newHour" /> 
                </div>
            </div>

            <hr class="mt-5">

            <div class="d-flex flex-row justify-center gap-20 mt-3">
                <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                <button class="btn btn-primary text-center" (click)="rescheduleCampaign();">Reprogramar campaña</button>
            </div>
        </div>
    </div>
</div>